import type { ModelDefinition, ModelName } from "./types";

export const defineModel = <N extends ModelName>(definition: ModelDefinition<N>) => definition;
